import { render, staticRenderFns } from "./BankInstructionCreateEdit.vue?vue&type=template&id=8864f478&scoped=true&"
import script from "./BankInstructionCreateEdit.vue?vue&type=script&lang=js&"
export * from "./BankInstructionCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./BankInstructionCreateEdit.vue?vue&type=style&index=0&id=8864f478&prod&lang=scss&scoped=true&"
import style1 from "./BankInstructionCreateEdit.vue?vue&type=style&index=1&id=8864f478&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8864f478",
  null
  
)

export default component.exports